import CityServicePage from "@/pages/city-service/CityServicePage";
import { etobicokeHeatingCooling } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={etobicokeHeatingCooling} />; }
